var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSoftwareTestersinline = function SvgSoftwareTestersinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#7D64FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.205a8.8 8.8 0 1 0 0 17.6 8.8 8.8 0 0 0 0-17.6Zm-11.2 8.8c0-6.186 5.015-11.2 11.2-11.2 6.186 0 11.2 5.014 11.2 11.2 0 2.665-.93 5.112-2.485 7.035.047.035.091.073.134.115l4 4a1.2 1.2 0 1 1-1.698 1.697l-4-4a1.2 1.2 0 0 1-.115-.133A11.153 11.153 0 0 1 18 29.205c-6.185 0-11.2-5.015-11.2-11.2Zm15.65-1.614a1.3 1.3 0 1 0-1.9-1.774l-3.717 3.982-1.383-1.482a1.3 1.3 0 0 0-1.9 1.774l2.333 2.5a1.3 1.3 0 0 0 1.9 0l4.667-5Z",
    fill: "url(#software-testers_inline_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "software-testers_inline_svg__a",
    x1: 19.806,
    y1: 6.335,
    x2: 19.806,
    y2: 34.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#fff",
    stopOpacity: 0.8
  })))));
};
export default SvgSoftwareTestersinline;